<template>
    <div>
        <table v-if="groupList" class="datatable">
            <caption class="caption">Group list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminGroupList.table.name") }}</th>
                <th scope="col">{{ $t("admin.adminGroupList.table.enabled") }}</th>
                <th scope="col">{{ $t("admin.adminGroupList.table.transfer") }}</th>
            </tr>
            <tr v-for="(ws, index) in groupList" v-bind:key="index">
                <td><router-link :to="'/admin/groupView/' + ws.id">{{ ws.name }}</router-link></td>
                <td>{{ ws.enabled ? $t("common.yes") : $t("common.no") }}</td>
                <td>
                    <div v-if="ws.meterActive && !meterUnlimited">
                        <input maxlength="8" v-model="ws.transferAmount" type="text">&nbsp;<input type="submit" class="submit" v-bind:value="$t('admin.adminGroupList.button.transfer')" v-on:click="transferDown(ws)"/>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminGroupList',
        props: [ 'planId', 'meterUnlimited' ],
        data: function() {
            return { groupList: [] };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {
                console.log(this.meterUnlimited);
                adminService.groupList(this.planId).then((data) => {
                    data.forEach(function(ws) {
                        ws.transferAmount = 0;
                    });
                    this.groupList = data;
                }).catch((err) => {
                    console.error('Unable to list group: ', err)
                });
            },
            transferDown: function(ws) {
                adminService.transferCredits(ws.planId, ws.id, ws.transferAmount, "Transfer from plan to group").then(() => {
                    this.fetchData();
                    this.$parent.fetchData();
                }).catch((err) => {
                    console.error('Unable to transfer credits: ', err)
                });
            }
        }
    }
</script>
